import AbstractPiniaModel from './AbstractPiniaModel';
import { useAnswersStatsStore } from '../pinia/stores/answersStats'
import Api from 'Ajax'
import {checkApiResponseForAuth} from '@features/_common/errorHandler';


export class AnswerStats extends AbstractPiniaModel {
    constructor() { super() }

    static piniaStore() {
        return useAnswersStatsStore()
    }

    static existsFor(professionID) {
        return this.piniaStore().existsAnswerStatsFor(professionID)
    }

    static loadFromBackendFor(professionID) {
        return Api.getAnswerStatsFor(professionID)
                   .then( result => this.dispatch('addToAnswersStats', result.data) )
                   .catch( err => checkApiResponseForAuth(this.ebus(), err) )
                    //Todo: Better error handling
    }

    static getRemoteFor(professionID) {
        let getStats    = () => this.piniaStore().getAnswerStatsFor(professionID)
        return this.loadFromBackendFor(professionID).then(getStats)
    }

    static getLocalFor(professionID) {
        return this.piniaStore().getAnswerStatsFor(professionID);
    }
}
